<template>
  <div class="extra-category-modal">
    <c-alert is-close-btn @close="onConfirm">
      <template #content>
        <div class="modal-content">
          <div class="message">
            <span class="message-title">신청이 완료됐어요</span>
            <p class="message-sub">
              알림톡으로 추가 안내 드리겠습니다 :)<br />
              자세한 사항은 카카오톡 메시지를 참고해주세요
            </p>
          </div>
          <div class="buttons">
            <c-button
              :size="CButtonSize.L"
              :type="CButtonType.Fill"
              :variant="CButtonVariant.Primary"
              label="확인"
              @click="onConfirm"
            />
          </div>
        </div>
      </template>
    </c-alert>
  </div>
</template>

<script setup lang="ts">
import { CAlert, CButton, CButtonSize, CButtonType, CButtonVariant } from '@aj-fe/aj-vue-core'

const emit = defineEmits<{
  (e: 'confirm'): void
}>()

const onConfirm = () => emit('confirm')
</script>

<style lang="scss">
@use '@aj-fe/aj-vue-core/styles/theme' as theme;
@use './modal-shared' as shared;

.extra-category-modal {
  @include shared.alert-card;

  .c-alert-container .modal-content {
    .message {
      text-align: center;

      .message-title {
        display: block;
        @include theme.Heading-S;
        color: var(--c-gray900, #1f2429);

        @media (max-width: 1024px) {
          @include theme.Heading-XS;
        }
      }

      .message-sub {
        margin-top: 12px;
        @include theme.Body-S-400;
        color: var(--c-gray700, #575e64);

        @media (max-width: 1024px) {
          @include theme.Body-XS-400;
        }
      }
    }

    .buttons {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
}
</style>
